import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  styled,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "50px",
  textTransform: "capitalize",
  padding: "12px 20px",
  height: "3rem",
  color: theme.palette.text.blue,
  fontSize: "1rem",
}));

export default function ReportsSection() {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("md"));

  const reportList = [
    {
      id: "report",
      title: "Need A BPO Report?",
      info: `BPO reports offer an informal estimation of your property's value for selling, buying, financing, or other needs.`,
      ctaBtn: "Order BPO Report",
      link: `${process.env.REACT_APP_BPOHOMESTECH_REDIRECT}order-bpo-report`,
    },
    {
      id: "proforma",
      title: "Need A Proforma Report?",
      info: `BPO reports offer an informal estimation of your property's value for selling, buying, financing, or other needs.`,
      ctaBtn: "Order Proforma Report",
      link: `${process.env.REACT_APP_BPOHOMESTECH_REDIRECT}analyze-deal`,
    },
  ];

  return (
    <Box sx={{ py: 5 }}>
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          px: 2.5,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Grid container spacing="1.5rem">
            {reportList.map((report, index) => (
              <Grid key={report.id} item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xs: "center",
                      md: index === 0 ? "flex-end" : "flex-start",
                    },
                    height: "100%",
                  }}
                >
                  <Card
                    sx={{
                      borderRadius: 2,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "background.alternate.2",
                      color: "white",
                      // maxWidth: "616px",
                    }}
                  >
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        p: { xs: 2.5, md: 4 },
                        height: "100%",
                      }}
                    >
                      <Stack
                        justifyContent="space-between"
                        alignItems="flex-start"
                        height="100%"
                        gap={5}
                      >
                        <Stack width={{ xs: "100%", md: "95%" }} gap={1.5}>
                          <Typography
                            variant="h4"
                            component="h2"
                            fontWeight="600"
                            fontSize={{ xs: "1.75rem", md: "2rem" }}
                          >
                            {report.title}
                          </Typography>

                          <Typography
                            variant="body1"
                            fontSize={"18px"}
                            sx={{ opacity: 0.9, lineHeight: "1.7" }}
                          >
                            {report.info}
                          </Typography>
                        </Stack>

                        <a
                          href={report.link}
                          target={report.link ? "_blank" : "_top"}
                          rel="noreferrer"
                        >
                          <StyledButton
                            variant="contained"
                            color="inherit"
                            sx={{
                              width: { xs: "100%", sm: "auto" },
                            }}
                          >
                            {report.ctaBtn}
                          </StyledButton>
                        </a>
                      </Stack>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
}
